import React, { useState, useEffect } from 'react';
import N3rveLogo from './../../../images/N3rveLogo.png'
import N3rvousLogo from './../../../images/nervouslogo.png'
import N3rvePlusLogo from './../../../images/nervouspluslogo.png'
import N3rveProLogo from './../../../images/nerveprologo.png'
import CheckCircle from './../../../images/checkcircle.png'
import './SelectPlan.css'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next'
import i18next from "i18next"
import axios from 'axios'
import Cookies from 'universal-cookie';
import { logtoWix } from '../../Helpers/LogToWix';


function SelectPlan() {
   const [planSelect, setPlanSelect] = useState(0);
   const location = useLocation();
   const { t, i18n } = useTranslation();
   const navigate = useNavigate();
   const cookies = new Cookies(null, { path: '/' });



   const HandleClick = (no) => {
      setPlanSelect(no);
   }

   const [dimensions, setDimensions] = useState({
      height: window.innerHeight,
      width: window.innerWidth
   })

   const SelectPlan = () => {
      // navigate("/AccountDetails",{state:{
      //    email:location.state.email
      //    }})
      navigate("/payment", {
         state: {
            email: location.state.email
         }
      })
      //    axios({
      //       method:'post',
      //       url:"https://n3rve.fly.dev/auth/plan",
      //       headers:{
      //           Authorization: "Bearer ".concat(cookies.get("token"))
      //       },
      //       data:{
      //         "plan":"pro",
      //       }
      //   }).then((response)=>{
      //     if(response.status===200){
      //       console.log(response)

      //     }
      //   }).catch(function (e){
      //     console.log(e.response)
      //   })   
   }



   useEffect(() => {
      function handleResize() {
         setDimensions({
            height: window.innerHeight,
            width: window.innerWidth
         })

      }

      window.addEventListener('resize', handleResize)

      return _ => {
         window.removeEventListener('resize', handleResize)
      }
   })

   useEffect(() => {
      console.log("Email")
      console.log(location.state.email)
   }, [])

   return (
      <div className="SelectPlanContainer" style={{ width: '100%', height: '100vh', paddingBottom: '5em' }}>
         <Link to="/" style={{ textDecoration: 'none' }}>
            <img src={N3rveLogo} style={{ width: '5.58em', height: '1em', marginTop: '1.75em', marginLeft: '9.5em' }} />
         </Link>

         <div className='SelectPlanH1'>{t('Selectyourplan')}</div>

         <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '9.5em' }} >
            {
               planSelect === 1 &&
               <div className='PlanCardContainer' style={{ backgroundColor: 'rgba(255,255,255,0.1)', border: 'white solid 1.5px' }} onClick={() => setPlanSelect(1)} >
                  <img src={N3rvousLogo} style={{ width: '1.5em', height: '1.5em', marginLeft: '1.5em', marginTop: '2.5em', marginBottom: '0.5em' }} />
                  <div className='PlanName' style={{ marginLeft: '0.85em' }}>{t('Nervous')}</div>
                  <div className='PlanPrice'>{t('Freetojoin')}</div>
                  <div className='PlanJoinBtnfree' onClick={() => navigate("/AccountDetails", { state: { email: location.state.email } })}>
                     JOIN FOR FREE
                     <div className="HoverOverlay" style={{ top: '0em' }} />
                  </div>

                  <div className='UpgradeTxt'>
                     *You can upgrade anytime.
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '1.15em' }}>
                     <img src={CheckCircle} alt="Check circle" className='CheckCircleImg' />
                     <div className='PlanListItem'>{t('Delivertosm')}</div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '1.15em' }}>
                     <img src={CheckCircle} alt="Check circle" className='CheckCircleImg' />
                     <div className='PlanListItem'>{t('Dspreleasetoplat')}</div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                     <img src={CheckCircle} alt="Check circle" className='CheckCircleImg' />
                     <div className='PlanListItem'>{t('Take90percroyal')}</div>
                  </div>





               </div>
            }

            {
               planSelect !== 1 &&
               <div className='PlanCardContainer' onClick={() => setPlanSelect(1)}>
                  <img src={N3rvousLogo} style={{ width: '1.5em', height: '1.5em', marginLeft: '1.5em', marginTop: '2.5em', marginBottom: '0.5em' }} />
                  <div className='PlanName' style={{ marginLeft: '0.85em' }}>{t('Nervous')}</div>
                  <div className='PlanPrice'>{t('Freetojoin')}</div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '1.15em' }}>
                     <img src={CheckCircle} alt="Check circle" className='CheckCircleImg' />
                     <div className='PlanListItem'>{t('Delivertosm')}</div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '1.15em' }}>
                     <img src={CheckCircle} alt="Check circle" className='CheckCircleImg' />
                     <div className='PlanListItem'>{t('Dspreleasetoplat')}</div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                     <img src={CheckCircle} alt="Check circle" className='CheckCircleImg' />
                     <div className='PlanListItem'>{t('Take90percroyal')}</div>
                  </div>


               </div>
            }

            {
               planSelect === 2 &&
               <div className='PlanCardContainer' style={{ backgroundColor: 'rgba(255,255,255,0.1)', border: 'white solid 1.5px' }} onClick={() => setPlanSelect(2)} >
                  <div className='MostPopularBtn'>{t('Mostp')}</div>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                     <img src={N3rvePlusLogo} style={{ width: '1.5em', height: '1.5em', marginLeft: '1.5em', marginTop: '2.5em', marginBottom: '0.5em' }} />
                  </div>
                  <div className='PlanName' style={{ marginLeft: '0.85em' }}>{t('Nervousplus')}</div>
                  <div className='PlanPrice'>{t('12months19')}</div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '1.15em' }}>
                     <img src={CheckCircle} alt="Check circle" className='CheckCircleImg' />
                     <div className='PlanListItem'>{t('Includesalbenifits')}</div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '1.15em' }}>
                     <img src={CheckCircle} alt="Check circle" className='CheckCircleImg' />
                     <div className='PlanListItem'>{t('Brandyourself')}</div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '1.15em' }}>
                     <img src={CheckCircle} alt="Check circle" className='CheckCircleImg' />
                     <div className='PlanListItem'>{t('Take100percroyal')}</div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '1.15em' }}>
                     <img src={CheckCircle} alt="Check circle" className='CheckCircleImg' />
                     <div className='PlanListItem'>{t('Unlimiteddsprel')}</div>
                  </div>

                  <div className='PlanJoinBtnfree' style={{ marginTop: '1em' }} onClick={() => { logtoWix(location.state.email, "auth", "Select Plan Page", { "desc": "User selected N3RVE Premier Plan" }); cookies.set('plan', "Premier"); navigate("/payment") }}>
                     JOIN
                     <div className="HoverOverlay" style={{ top: '0em' }} />
                  </div>

                  <div className='UpgradeTxt'>
                     *You can cancel your trial any time.
                  </div>

                  {/* <div className='PlanJoinBtn' onClick={()=>SelectPlan()}>
                     JOIN 14-DAYS TRIAL
                  </div>
      

                 <div className='PlanCancelTxt'  >*You can cancel your trial any time.</div> */}
               </div>
            }

            {
               planSelect !== 2 &&
               <div className='PlanCardContainer' onClick={() => setPlanSelect(2)}>
                  <div className='MostPopularBtn'>MOST POPULAR</div>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                     <img src={N3rvePlusLogo} style={{ width: '1.5em', height: '1.5em', marginLeft: '1.5em', marginTop: '2.5em', marginBottom: '0.5em' }} />
                  </div>
                  <div className='PlanName' style={{ marginLeft: '0.85em' }}>{t('Nervousplus')}</div>
                  <div className='PlanPrice'>{t('12months19')}</div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '1.15em' }}>
                     <img src={CheckCircle} alt="Check circle" className='CheckCircleImg' />
                     <div className='PlanListItem'>{t('Includesalbenifits')}</div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '1.15em' }}>
                     <img src={CheckCircle} alt="Check circle" className='CheckCircleImg' />
                     <div className='PlanListItem'>{t('Brandyourself')}</div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '1.15em' }}>
                     <img src={CheckCircle} alt="Check circle" className='CheckCircleImg' />
                     <div className='PlanListItem'>{t('Take100percroyal')}</div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '1.15em' }}>
                     <img src={CheckCircle} alt="Check circle" className='CheckCircleImg' />
                     <div className='PlanListItem'>{t('Unlimiteddsprel')}</div>
                  </div>

               </div>
            }

            {
               planSelect === 3 &&
               <div className='PlanCardContainer' style={{ backgroundColor: 'rgba(255,255,255,0.1)', border: 'white solid 1.5px' }} onClick={() => setPlanSelect(3)} >
                  <img src={N3rveProLogo} style={{ width: '1.5em', height: '1.5em', marginLeft: '1.5em', marginTop: '2.5em', marginBottom: '0.5em' }} />
                  <div className='PlanName' style={{ marginLeft: '0.85em' }}>{t('Nervepro')}</div>
                  <div className='PlanPrice'>{t('12months49')}</div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '1.15em' }}>
                     <img src={CheckCircle} alt="Check circle" className='CheckCircleImg' />
                     <div className='PlanListItem'>{t('Nerveplusbenefits')}</div>
                  </div>



                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '1.15em' }}>
                     <img src={CheckCircle} alt="Check circle" className='CheckCircleImg' />
                     <div className='PlanListItem'>{t('Youtubemonet')}</div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                     <img src={CheckCircle} alt="Check circle" className='CheckCircleImg' />
                     <div className='PlanListItem'>{t('Exclusivebranddeals')}</div>
                  </div>


                  <div className='PlanJoinBtnfree' style={{ marginTop: '5em' }} onClick={() => { logtoWix(location.state.email, "auth", "Select Plan Page", { "desc": "User selected N3RVE Pro Plan" }); cookies.set('plan', "N3RVE"); navigate("/payment") }}>
                     JOIN
                     <div className="HoverOverlay" style={{ top: '0em' }} />
                  </div>

                  <div className='UpgradeTxt'>
                     *You can cancel your trial any time.
                  </div>
               </div>
            }

            {
               planSelect !== 3 &&
               <div className='PlanCardContainer' onClick={() => setPlanSelect(3)}>
                  <img src={N3rveProLogo} style={{ width: '1.5em', height: '1.5em', marginLeft: '1.5em', marginTop: '2.5em', marginBottom: '0.5em' }} />
                  <div className='PlanName' style={{ marginLeft: '0.85em' }}>{t('Nervepro')}</div>
                  <div className='PlanPrice'>{t('12months49')}</div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '1.15em' }}>
                     <img src={CheckCircle} alt="Check circle" className='CheckCircleImg' />
                     <div className='PlanListItem'>{t('Nerveplusbenefits')}</div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '1.15em' }}>
                     <img src={CheckCircle} alt="Check circle" className='CheckCircleImg' />
                     <div className='PlanListItem'>{t('Youtubemonet')}</div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                     <img src={CheckCircle} alt="Check circle" className='CheckCircleImg' />
                     <div className='PlanListItem'>{t('Exclusivebranddeals')}</div>
                  </div>

               </div>
            }

         </div>
      </div>
   );
}

export default SelectPlan;